import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css"; // External CSS

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footerContainer">
        {/* Jaiguru Jewellers Info */}
        <div className="footerSection">
          <h3>VIMAL JEWELLERY</h3>
          <p>38/40. AMARAPATHI VINAYAGAR KOVIL NEAR KAMARAJAR STREET, Viluppuram DT, PinCode: 605 602</p>
          <p>MOBILE : 93333 33092,94430 91392</p>
        </div>

        {/* Important Links */}
        <div className="footerSection">
          <h4>Important Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        {/* Policies & Admin Login */}
        <div className="footerSection">
          <h4>Policies</h4>
          <ul>
            <li><Link to="/PrivacyPolicy">Privacy Policy</Link></li>
            <li><Link to="/TermsAndCondition">Terms & Conditions</Link></li>
            <li><Link to="/CancellationPolicy">Cancellation Policy</Link></li>
            <li><Link to="/RefundPolicy">Refund Policy</Link></li>
            <li><Link to="/login">Admin Login</Link></li>
          </ul>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footerBottom">
        <a href="https://www.brightechsoftware.com/" target="_blank" rel="noreferrer noopener">
          &copy; {new Date().getFullYear()} Brightech Software Solution
        </a>
      </div>
    </footer>
  );
};

export default Footer;
